import {
  CountedNotPaidSalaryType,
  CountedSalariesFullInfoByEmployeeType,
  CountedSalariesFullInfoType,
  SalaryItem,
} from '@expane/data'

export interface CountedSalaryType {
  servicesSalary: number
  premiumSalary: number
  accruedSalary: number
  referralPercentageSalary: number
  rateSalary: number
}

export const calcTotalSalaryItemsSum = (
  salaryItems: Array<SalaryItem | CountedNotPaidSalaryType>,
) =>
  salaryItems.reduce(
    (sum, salaryItem) => (salaryItem.totalSum ? sum + salaryItem.totalSum : sum),
    0,
  )

export const getEmployeeSalaryFromCountedSalariesFullInfo = (
  salariesFullInfo: Array<CountedSalariesFullInfoType>,
  employeeId: number,
) => {
  for (let i = 0; i < salariesFullInfo.length; i++) {
    for (let s = 0; s < salariesFullInfo[i].salaries.length; s++) {
      if (salariesFullInfo[i].salaries[s].employeeId === employeeId) {
        return salariesFullInfo[i].salaries[s]
      }
    }
  }
}

export const extractNotPaidSalaryFromCountedSalariesFullInfo = (
  countedSalariesFullInfo: Array<CountedSalariesFullInfoByEmployeeType>,
) => {
  return countedSalariesFullInfo.map(({ notPaidSalary }) => notPaidSalary)
}
